import React from "react";
import {Box, Divider, makeStyles, Typography} from "@material-ui/core";
import {useCurrency} from "../../../common/common";
import PropTypes from "prop-types";
import {Skeleton} from "@material-ui/lab";
import {useBreakpoints} from "../../../hooks";

const useStyles = makeStyles((theme) => ({
    textLineThrough: {
        textDecoration: "line-through"
    },
    discountPrice: {
        fontWeight: "600",
        [theme.breakpoints.up("sm")]: {
            marginLeft: theme.spacing(0.5),
        },
    },
    description: {
        color: "rgba(0, 0, 0, 0.64)"
    },
}));


const PriceCost = ({
    title,
    description,
    price,
    discountPrice,
    currency,
    discounts,
    divider
}) => {
    const classes = useStyles();
    const {formatCurrency} = useCurrency();
    const {isExtraSmallScreen} = useBreakpoints();

    return (
        <>
            <Box
                display={"flex"}
                justifyContent={"space-between"}
                gridGap={(isExtraSmallScreen()) ? 5 : 0}
            >
                <Box>
                    <Typography variant="body1">
                        {title}
                    </Typography>
                    <Typography
                        variant="body2"
                        className={classes.description}
                    >
                        {description}
                    </Typography>
                </Box>
                <Box
                    display="flex"
                    flexDirection={isExtraSmallScreen() ? "column" : "row"}
                    alignItems={isExtraSmallScreen() ? "baseline" : "start"}
                    minWidth="fit-content"
                >
                    {price !== undefined ? (
                        <>
                            {discountPrice !== undefined ? (
                                <>
                                    <Typography
                                        component="span"
                                        variant="body1"
                                        className={classes.textLineThrough}
                                    >
                                        {formatCurrency(currency, price)}
                                    </Typography>
                                    <Typography
                                        component="span"
                                        variant="body1"
                                        className={classes.discountPrice}
                                    >
                                        {formatCurrency(currency, discountPrice)}
                                    </Typography>
                                </>
                            ) : <Typography variant="body1">{formatCurrency(currency, price)}</Typography>
                            }
                        </>
                    ) : <Skeleton width={120} />
                    }
                </Box>
            </Box>

            {React.isValidElement(discounts) && (discounts)}

            {divider &&
                <Box my={2}>
                    <Divider />
                </Box>
            }
        </>
    );
};

PriceCost.propTypes = {
    price: PropTypes.number,
    discountPrice: PropTypes.number,
    currency: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    discounts: PropTypes.element,
    divider: PropTypes.bool
};

export default PriceCost;
